import script from "./TabPreReportDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabPreReportDownload.vue?vue&type=script&setup=true&lang=ts"

import "./TabPreReportDownload.vue?vue&type=style&index=0&id=285431ca&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285431ca"]])

export default __exports__